import { Field } from "@kanda-libs/ks-component-ts";
import type { FunctionComponent } from "react";
import CompanyRow from "./CompanyRow";
import useCidLookup from "./useCidLookup";

export interface CidLookupInputProps {
  onChange: (cid?: string) => void;
}

const CidLookupInput: FunctionComponent<CidLookupInputProps> = function ({
  onChange,
}) {
  const {
    searchTerm,
    results,
    cid,
    setCid,
    company,
    onChange: inputOnChange,
    onFocus,
  } = useCidLookup(onChange);

  return (
    <div>
      <Field.UncontrolledInput
        name="cid"
        value={searchTerm}
        onChange={inputOnChange as (...args: unknown[]) => void}
        onFocus={onFocus}
      />
      {searchTerm && !cid && (
        <div className="flex flex-col pt-2 gap-y-2">
          {results.slice(0, 5).map((company) => (
            <CompanyRow
              company={company}
              onSelect={() => {
                setCid(company.cid || "");
                onChange(company.cid);
              }}
            />
          ))}
        </div>
      )}
      {company && (
        <div className="mt-4">
          <CompanyRow selected company={company} />
        </div>
      )}
    </div>
  );
};

export default CidLookupInput;
